import React, { useState } from 'react';
import { View } from 'react-native';
import { ReceiptCard, ReceiptSplitDetailsModal } from '@cubemeet/ui';
import type { ReceiptData } from '@cubemeet/ui';

export interface ReceiptSectionWebProps {
  receipt: ReceiptData;
  onUpload: () => void;
  onExportPDF?: () => void;
  isExporting?: boolean;
  t?: (key: string) => string;
  // When true, the parent is rendering header actions (PDF/Upload).
  // In that case we don't want each item to show the header buttons again.
  showHeaderActions?: boolean;
  formatCurrency?: (amount: number, currency?: string) => string;
  onApprove?: (receiptId: string) => void;
  onRequestReject?: (receiptId: string) => void;
}

const ReceiptSectionWeb: React.FC<ReceiptSectionWebProps> = ({ receipt, onUpload, onExportPDF, isExporting, t, showHeaderActions = false, formatCurrency, onApprove, onRequestReject }) => {
  const [modalVisible, setModalVisible] = useState(false);

  const wrappedUpload = () => {
    if (onUpload) {
      console.log('[ReceiptSectionWeb] calling onUpload');
      onUpload();
    } else {
      console.warn('[ReceiptSectionWeb] onUpload is undefined');
    }
  };

  const handlePress = () => {
    // Only open modal when we have member split info (private receipts)
    if ((receipt as any).members && Array.isArray((receipt as any).members) && (receipt as any).members.length > 0) {
      setModalVisible(true);
    } else {
      // no members: still allow default onPress hook if caller provided (noop by default)
      console.log('[ReceiptSectionWeb] no split members for receipt', receipt.id);
    }
  };

  return (
    <View>
      <ReceiptCard
        receipt={receipt}
        onPress={handlePress}
        formatCurrency={(amount, currency) => (formatCurrency ? formatCurrency(amount, currency) : `${currency}${amount}`)}
        t={t}
        onUpload={wrappedUpload}
        onExportPDF={onExportPDF}
        isExporting={!!isExporting}
        // hide per-item header actions when parent already rendered them
        showActions={!showHeaderActions}
        onApprove={onApprove}
        onRequestReject={onRequestReject}
      />

      <ReceiptSplitDetailsModal
        visible={modalVisible}
        onClose={() => setModalVisible(false)}
        receipt={receipt as any}
        currentUserId={undefined}
        formatCurrency={(amount, currency) => (formatCurrency ? formatCurrency(amount, currency) : `${currency}${amount}`)}
      />
    </View>
  );
};

export default ReceiptSectionWeb;
